import { useEffect,useState } from 'react';
import {fetchRegions} from '@/services/api'

export const useRegions = () => {
  const [regions,setRegions] = useState([])
  const [selectedRegion,setSelectedRegion] = useState();
  const [error,setError] = useState()
  const [loading,setLoading] = useState(false)

  console.log("fetching regions")
  const handleRegionSelect= (region)=>{
    setSelectedRegion(region)
  }
  const clearRegionSelection = ()=>{
    setSelectedRegion(null);
  }

  useEffect(() => {
    const loadRegions = async () => {
      try {
        setLoading(true);
        const data = await fetchRegions();
        setRegions(data.regions);
      } catch (err) {
        setError('Failed to load regions');
      } finally {
        setLoading(false);
      }
    };
    loadRegions();
  }, []);

  return {
    regions,
    selectedRegion,
    loading,
    error,
    handleRegionSelect,
    clearRegionSelection
  };
};